/* eslint-disable prettier/prettier */

import {
  createObjectURL,
  createValidAbsoluteUrl,
  // isPdfFile,
} from "./pdfjs-lib.js";
import { apiCompatibilityParams } from "../src/display/api_compatibility.js";

if (typeof PDFJSDev !== "undefined" && !PDFJSDev.test("CHROME || GENERIC")) {
  throw new Error(
    'Module "pdfjs-web/download_manager" shall not be used ' +
      "outside CHROME and GENERIC builds."
  );
}

const DISABLE_CREATE_OBJECT_URL =
  apiCompatibilityParams.disableCreateObjectURL || false;

class DownloadManager {
  constructor(disableCreateObjectURL = DISABLE_CREATE_OBJECT_URL) {
    this.disableCreateObjectURL = disableCreateObjectURL;
  }

  tw2018func_download(blobUrl, filename) {
    const a = document.createElement("a");
    if (!a.click) {
      throw new Error('DownloadManager: "a.click()" is not supported.');
    }

    a.href = blobUrl;
    a.target = "_parent";
    // Use a.download if available. This increases the likelihood that
    // the file is downloaded instead of opened by another PDF plugin.
    // if ('download' in a)
    a.download = filename;

    // <a> must be in the document for IE and recent Firefox versions,
    // otherwise .click() is ignored.
    (document.body || document.documentElement).appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () {
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  }

  downloadUrl(url, filename) {
    if (!createValidAbsoluteUrl(url, "http://example.com")) {
      return; // restricted/invalid URL
    }
    this.tw2018func_download(url, filename);
  }

  downloadData(data, filename, contentType) {
    const newBlob = new Blob([data], { type: contentType });
    if (navigator.msSaveBlob) {
      // IE10 and above
      return navigator.msSaveBlob(newBlob, filename);
    }
    const blobUrl = createObjectURL(
      data,
      contentType,
      this.disableCreateObjectURL
    );

    // let blobUrl = window.URL.createObjectURL(newBlob);
    this.tw2018func_download(blobUrl, filename);
    return true;
  }

  download(blob, url, filename) {
    if (navigator.msSaveBlob) {
      // IE10 / IE11
      if (!navigator.msSaveBlob(blob, filename)) {
        this.downloadUrl(url, filename);
      }
      return;
    }

    if (this.disableCreateObjectURL) {
      // URL.createObjectURL is not supported
      this.downloadUrl(url, filename);
      return;
    }

    const blobUrl = URL.createObjectURL(blob);
    this.tw2018func_download(blobUrl, filename);
  }
}

export { DownloadManager };
